import React from 'react';
import Card from './Card';

const CardList = ({games}) => {
    const cardArray = games.map((user, i) => {
        return <Card 
                    key={i} 
                    id={games[i].id} 
                    name={games[i].name} 
                    rating={games[i].rating} 
                    releaseDate={games[i].released}
                    image={games[i].background_image}
                    metacritic={games[i].metacritic}
                    genres={games[i].genres.map((item) => {return item.name}).join(', ')} />
    })
    return (
        <div>
            {cardArray}  
        </div>
    );
}

export default CardList;